import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUser } from '../data/session';

const MobileNav: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const role = getCurrentUser().role;

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const founderItems = [
    { path: '/app/dashboard/founder', label: 'Dashboard' },
    { path: '/app/journey', label: 'My Journey' },
    { path: '/app/lms/courses', label: 'Coursework' },
    { path: '/app/sessions', label: 'Sessions' },
    { path: '/app/startup', label: 'My Startup' },
    { path: '/app/pitch/idea', label: 'Pitch' },
    { path: '/app/notifications', label: 'Notifications' },
    { path: '/app/settings', label: 'Settings' },
  ];

  const mentorItems = [
    { path: '/app/dashboard/mentor', label: 'Dashboard' },
    { path: '/app/sessions', label: 'Sessions' },
    { path: '/app/pitch/review', label: 'Pitch Reviews' },
    { path: '/app/notifications', label: 'Notifications' },
    { path: '/app/settings', label: 'Settings' },
  ];

  const adminItems = [
    { path: '/app/dashboard/admin', label: 'Dashboard' },
    { path: '/app/admin/users', label: 'Users' },
    { path: '/app/admin/mentors', label: 'Mentors' },
    { path: '/app/admin/courses', label: 'Courses' },
    { path: '/app/admin/phases', label: 'Phases' },
    { path: '/app/admin/sessions', label: 'Sessions' },
    { path: '/app/admin/investors', label: 'Investors' },
    { path: '/app/analytics', label: 'Analytics' },
    { path: '/app/settings', label: 'Settings' },
  ];

  const investorItems = [
    { path: '/app/dashboard/investor', label: 'Dashboard' },
    { path: '/app/investor/pitches', label: 'Pitches' },
    { path: '/app/notifications', label: 'Notifications' },
    { path: '/app/settings', label: 'Settings' },
  ];

  const navItems = role === 'admin' ? adminItems
    : role === 'mentor' ? mentorItems
    : role === 'investor' ? investorItems
    : founderItems;

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden fixed top-4 left-4 z-50 p-3 bg-shell border border-line rounded-lg text-text shadow-lg"
        aria-label="Open navigation menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
      {isOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-black/30" onClick={() => setIsOpen(false)}>
          <div
            className="w-72 h-full bg-shell border-r border-line p-6 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-8">
              <img src="/logo.png" alt="BunyadKar" className="h-9 w-auto" />
            </div>
            <nav className="space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`
                    flex items-center gap-3 px-4 py-3 rounded-lg transition-colors
                    ${isActive(item.path)
                      ? 'bg-accent-soft text-chart font-medium'
                      : 'text-text hover:bg-surface'
                    }
                  `}
                >
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
            </nav>
            <div className="mt-8 pt-6 border-t border-line">
              <button
                onClick={() => {
                  window.location.href = '/login';
                }}
                className="flex items-center gap-3 px-4 py-3 text-danger hover:bg-danger/5 rounded-lg transition-colors w-full text-left"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Logout</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav;
